
    function customer_name(){
      var url_main = $('ul.rct_navigation__desktop li.rct_navigation__item:nth-child(1) a').attr('href');
     $.ajax({
          type:"GET",
          datatype:"HTML",
          url: url_main,
          success: function(data){ 
          var title = $(data).find('section.rct_content h1').html(); 
          $('<h4 class="customer_name">'+title+'</h4>').insertBefore('section.rct_content .rct_content-header');   
          }
}); 
    }
    $(document).ready(function(){
    customer_name();  
    });
    var check_intervl = setInterval(function(){
      if($('section.rct_content').length){
        $('<div class="flex_wrp"></div>').insertAfter('section.rct_content .rct_content-header');    
        $('<span class="bundle_pack" style="display:none">Bundle Pack</span>').appendTo('.flex_wrp');
        $('<div class="frequency_drop"><select id="frequency_drop" style="display:none;"></select></div>').insertAfter('span.bundle_pack');
        $('<div class="outer_loop" style="display:none;"></div>').insertAfter('.flex_wrp');
        $('<div class="mobile_sec" style="display:none;"><div class="date_sec"><span class="next_date-sec"></span><span class="change_date">Change Date</span></div><div class="your_box"><span class="heading">Your Box</span><span class="edit_box">Edit Your Box</span></div><div class="pack_price"><span class="pack_name"></span><span class="pack_prc"></span></div></div>').insertBefore('.outer_loop');
        $('<span class="add_product">EDIT PRODUCTS</span>').insertBefore('.rct_content-header__actions a');
        $('<span class="update_shipmnt">Update Next Shipment</span>').insertAfter('.rct_content-header__actions span.add_product');
        $('.outer_loop').next('.rct_subscriptions__container').next('h3').hide();   
        var outer_arr = [];
        var total=0;
        $('.outer_loop').next('.rct_subscriptions__container').find('.rct_card').each(function(){
          var text = $(this).find('.rct_card__content').children('p.rct_text--small:nth-child(3)').text();
          var id_number = parseInt(text.replace(/[^0-9.]/g, ""));
          $('select#frequency_drop').attr('check',id_number);
          var link_main = $(this).attr('data-subscription-item'); 
          outer_arr.push(link_main);
          function outer_loop(){
          var check_pot = outer_arr.shift();
          $.ajax({
          type:"GET",
          datatype:"HTML",
          url: check_pot,
          success: function(data){ 
            var title = $(data).find('.rct_subscription__title').html();           
            var image = $(data).find('.rct_subscription__image__container img').attr('src');
            var quantity = $(data).find('.rct_card--quantity strong').text();
            var quantity2 = parseInt(quantity);
             total = total+quantity2;  
          $('<div class="inner_loop" token="'+link_main+'"><div class="inner_block"><div class="img_sec"><img src="'+image+'"></div><div class="pro_meta"><div class="pro_title">'+title+'</div><div class="outer_main"><span class="main_qty">QTY: '+quantity+'</span><div class="qty_sec"><span class="qty_minus">-</span><input type="text" name="update-qty" id="qunty_box" value="'+quantity+'" min="1" pattern="[0-9]*"><span class="qty_plus">+</span></div><span class="swap_pro">Swap Product</span></div><span class="remove_prod">&times;</span></div></div></div>').appendTo('.outer_loop');
          $('<div class="inner_slide mySlides fader"><div class="flex_wrp"><div class="left_sec"><div class="img_sec"><img src="'+image+'"></div></div><div class="ryt_sec"><h3 class="pro_title">'+title+'</h3><div class="slide_qty-updt"><span class="main_qty">QTY: </span><span class="qty_minus-slide">-</span><input type="text" name="update-qty_slide" id="qunty_box-slide" value="'+quantity+'" min="1" pattern="[0-9]*"><span class="qty_plus-slide">+</span></div></div></div></div>').appendTo('.edit_drawer .slider_sec-top'); 
           // FOR DISPLAY NEXT SHIPPING DATE
            var next_date = $(data).find('.rct_card--next-charge strong').text();
            var next_datee = next_date.match(/\d+/);
            if(next_datee == '' || next_datee == null){
            }
            else {
            $('div#calender_modal span.current_date').text(next_date); 
              if($('span.next_shpng').length == 0){
            $('<span  class="next_shpng">Next Shipping :'+next_date+'</span>').insertAfter('section.rct_content .rct_content-header__title h3');
              }
            $('.mobile_sec .date_sec span.next_date-sec').text('Next Order:'+next_date); 
            }
            if(outer_arr.length > 0){
              outer_loop();
            }
            if(outer_arr.length == 0){
              $('.outer_loop').show(); 
              $('section.rct_content span.bundle_pack').show();
              if(total > 0 && total <= 12){         
                $('section.rct_content span.bundle_pack').html('12-Pack Bundle<span class="prc_pck">$53.52</span>'); 
                $('.custom_modal .add_product-meta span.total_products').html('12-Pack Bundle <span class="prc_pck">$53.52</span>');
                $('.edit_drawer .accordian_sec span.total_count').text(+total+'/12');
                $('.mobile_sec .pack_price span.pack_name').text('12-Pack Bundle');
                $('.mobile_sec .pack_price span.pack_prc').text('$53.52');
              }
              else if(total > 12 && total <= 24 ){
                $('section.rct_content span.bundle_pack').html('24-Pack Bundle<span class="prc_pck">$89.92</span>');
                $('.custom_modal .add_product-meta span.total_products').html('24-Pack Bundle <span class="prc_pck">$89.92</span>');
                $('.edit_drawer .accordian_sec span.total_count').text(+total+'/24');
                $('.mobile_sec .pack_price span.pack_name').text('24-Pack Bundle');
                $('.mobile_sec .pack_price span.pack_prc').text('$89.92');
              }
              else if(total > 24 && total <= 36){
                $('section.rct_content span.bundle_pack').html('36-Pack Bundle<span class="prc_pck">$134.88</span>');
                $('.custom_modal .add_product-meta span.total_products').html('36-Pack Bundle <span class="prc_pck">$134.88</span>');
                $('.edit_drawer .accordian_sec span.total_count').text(+total+'/36');
                $('.mobile_sec .pack_price span.pack_name').text('36-Pack Bundle');
                $('.mobile_sec .pack_price span.pack_prc').text('$134.88');
              }
              else if(total > 36 && total <= 48){
                $('section.rct_content span.bundle_pack').html('48-Pack Bundle<span class="prc_pck">$179.83</span>');
                $('.custom_modal .add_product-meta span.total_products').html('48-Pack Bundle <span class="prc_pck">$179.83</span>');
                $('.edit_drawer .accordian_sec span.total_count').text(+total+'/48');
                $('.mobile_sec .pack_price span.pack_name').text('148-Pack Bundle');
                $('.mobile_sec .pack_price span.pack_prc').text('$179.83');
              }
              else if(total > 48 && total <= 60) {
                $('section.rct_content span.bundle_pack').html('60-Pack Bundle<span class="prc_pck">$224.79</span>');
                $('.custom_modal .add_product-meta span.total_products').html('60-Pack Bundle <span class="prc_pck">$224.79</span>');
                $('.edit_drawer .accordian_sec span.total_count').text(+total+'/60');
                $('.mobile_sec .pack_price span.pack_name').text('60-Pack Bundle');
                $('.mobile_sec .pack_price span.pack_prc').text('$224.79');
              }
              else if(total > 60 && total <= 72) {
                $('section.rct_content span.bundle_pack').html('72-Pack Bundle<span class="prc_pck">$269.75</span>');
                $('.custom_modal .add_product-meta span.total_products').html('72-Pack Bundle <span class="prc_pck">$269.75</span>');
                $('.edit_drawer .accordian_sec span.total_count').text(+total+'/72');
                $('.mobile_sec .pack_price span.pack_name').text('72-Pack Bundle');
                $('.mobile_sec .pack_price span.pack_prc').text('$269.75');
              }
              else if(total > 72 && total <= 84) {
                $('section.rct_content span.bundle_pack').html('84-Pack Bundle<span class="prc_pck">$314.71</span>');
                $('.custom_modal .add_product-meta span.total_products').html('84-Pack Bundle <span class="prc_pck">$314.71</span>');
                $('.edit_drawer .accordian_sec span.total_count').text(+total+'/84');
                $('.mobile_sec .pack_price span.pack_name').text('84-Pack Bundle');
                $('.mobile_sec .pack_price span.pack_prc').text('$314.71');
              }
                 else if(total > 84 && total <= 96) {
                $('section.rct_content span.bundle_pack').html('96-Pack Bundle<span class="prc_pck">$359.67</span>');
                $('.custom_modal .add_product-meta span.total_products').html('96-Pack Bundle <span class="prc_pck">$359.67</span>');
                $('.edit_drawer .accordian_sec span.total_count').text(+total+'/96');
                $('.mobile_sec .pack_price span.pack_name').text('96-Pack Bundle');
                $('.mobile_sec .pack_price span.pack_prc').text('$359.67');
              }
                $('.custom_modal span.total_count').text(+total+" Products");
                $('.custom_modal span.total_count').show();
                $('.edit_drawer .edit-outer').show();
              } 
            }
        });
          }
          outer_loop();
        });
        clearInterval(check_intervl);
    $('<div class="cancel_subsc_pop"><span class="cancel_subsc">Cancel Subscription</span><span class="loader_img" style="display:none;"><img src="//cdn.shopify.com/s/files/1/0568/6840/5424/files/loader_218x.gif?v=1661952573"></span></div>').insertAfter('section.rct_content .outer_loop');
      }
    },1000);
    // FOR INSERT DYNAMIC FREQUENCY
    var main_intr = setInterval(function(){
    if($('.outer_loop .inner_loop').length){
      var title = $('.inner_loop:last-child() .pro_title h3').text();
      $('.product_outer .prod_loop[title="'+title+'"]').find('select[name="selling_plan"] option').each(function(index){
      var optn = $(this).attr('frequency');
      var option = optn.match(/\d+/)[0];
      $('<option value="'+option+'">'+optn+'</option>').appendTo('select#frequency_drop');
      });
     var id_number = $('select#frequency_drop').attr('check');
     $('select#frequency_drop').val(id_number).change();
     $('select#frequency_drop').show(); 
    clearInterval(main_intr); 
    }
    },500);
    // FOR QUANTITY SELECTOR
    $(document).on('click','span.qty_plus',function(){
      $('span.save_btn').remove();
      $('span.error_msg').remove();
      var valu = $(this).closest('.inner_loop').find('input[name="update-qty"]').val();
      $(this).closest('.inner_loop').addClass('update');
      valu++;
      if(valu >= 0){
        $(this).closest('.inner_loop').find('input[name="update-qty"]').attr("value", valu);
      }
      $('<span class="save_btn">Save</span>').insertAfter('.rct_content .rct_content-header__actions a');
      var total=0;
      $('.inner_loop').each(function(){
        var quantity =  $(this).find('input#qunty_box').val();
        if(quantity != undefined){
        var quantity2 = parseInt(quantity);
        total = total+quantity2; 
        }
      });
      if(total == 12 || total == 24 || total == 36){
        $('span.error_msg').remove();
        $('span.save_btn').css({'pointer-events':'inherit'});
      }
      else {
        $('<span class="error_msg">Please Add Quantity Multiple of 12.</span>').insertAfter('span.save_btn');
        $('span.save_btn').css({'pointer-events':'none'});
      }
    });
    $(document).on('click','span.qty_minus',function(){
      $('span.save_btn').remove();
     $('span.error_msg').remove(); 
      var valu = $(this).closest('.inner_loop').find('input[name="update-qty"]').val();
      $(this).closest('.inner_loop').addClass('update');
      valu--;
      if(valu >= 1){
        $(this).closest('.inner_loop').find('input[name="update-qty"]').attr("value", valu);
      }
     $('<span class="save_btn">Save</span>').insertAfter('.rct_content .rct_content-header__actions a'); 
      var total=0;
      $('.inner_loop').each(function(){
        var quantity =  $(this).find('input#qunty_box').val();
        if(quantity != undefined){
        var quantity2 = parseInt(quantity);
        total = total+quantity2;
        }
      });
      if(total == 12 || total == 24 || total == 36){
        $('span.error_msg').remove();
        $('span.save_btn').css({'pointer-events':'inherit'});
      }
      else {
        $('<span class="error_msg">Please Add Quantity Multiple of 12.</span>').insertAfter('span.save_btn'); 
        $('span.save_btn').css({'pointer-events':'none'});
      }
    });
    // FOR POPUP
    $(document).on('click','span.swap_pro',function(){
     $('.custom_modal').show(); 
      var token = $(this).closest('.inner_loop').attr('token');
      var quantity =  $(this).closest('.inner_loop').find('input#qunty_box').val();
      var frequency = $('select#frequency_drop').val();
     $('.product_outer').attr('token',token);
     $('.product_outer').attr('quantity',quantity);  
     $('.product_outer').attr('frequency',frequency);  
     $('body').addClass('overflow');
      $('.custom_modal .qty_changer').hide();
    });
    $(document).on('click','.custom_modal span.close',function(){
    $('.custom_modal').hide(); 
    $('body').removeClass('overflow');
    $('.shopify_products .product_outer').removeAttr('token');
    $('.shopify_products .product_outer').removeAttr('quantity');
    $('.shopify_products .product_outer').removeAttr('frequency');  
    });
    $(document).on('click','.product_outer .prod_loop',function(){
      $('.prod_loop').removeClass('active');
      $(this).addClass('active'); 
    });
    // FOR UPDATE SHIPMENT POPUP
    $(document).on('click','span.update_shipmnt',function(){
    $('.calender_modal').show(); 
     $('body').addClass('overflow');  
    });
    $(document).on('click','.calender_modal span.close',function(){
    $('.calender_modal').hide(); 
    $('body').removeClass('overflow');  
    });
    // UPDATE FREQUENCY
    $(document).on('change','select#frequency_drop',function(){
      var main_val = $(this).val();
      var outer_arry = [];
      $('.rct_card').each(function(){
        var link_main = $(this).attr('data-subscription-item'); 
        outer_arry.push(link_main);
      });
      function loop_main(){
        var check_pot = outer_arry.shift();
        var data = {"charge_interval_frequency":main_val,"order_interval_unit": "week","order_interval_frequency": main_val}
        $.ajax({
          type:"POST",
          url:check_pot,
          data : data,
          success : function(result) {
            loop_main();
          },
          error: function() {
          location.reload();
        }
        });
      }
      loop_main();
    });
    // UPDATE QUANTITY
    $(document).on('click','.rct_content-header__actions span.save_btn',function(){
      $(this).css({"pointer-events":"none"});
      var token_arr = [];
      var qty_arr = [];
      $('.inner_loop.update').each(function(){
      var url_main = $(this).attr('token');  
      var qty = $(this).find('input#qunty_box').val();
      token_arr.push(url_main);
      qty_arr.push(qty);
      });
      function update_qty(){
        var check_token = token_arr.shift();
        var check_qty = qty_arr.shift();
       var data = {"quantity":check_qty}
        $.ajax({
          type:"POST",
          url:check_token,
          data : data,
          success : function(result) {
           update_qty();
          },
          error: function () {
          location.reload();
        }
        }); 
      }
      update_qty();
    });
    // SWAP PRODUCT
    $(document).on('click','span.swap_btn',function(){
      var token = $('.product_outer').attr('token');
      var var_id = $('.custom_modal .prod_loop input[name="swap_pro"]:checked').val();
      var frequency = $('.product_outer').attr('frequency') ;
      var quantity = $('.product_outer').attr('quantity');
      $('.custom_modal').hide();
      var data = {"charge_interval_frequency":frequency ,"order_interval_frequency":frequency ,"order_interval_unit":"week","quantity":quantity ,"redirect_url":token,"shopify_variant_id":var_id}
      $.ajax({
        type:"POST",
        url:token,
        data : data,
        success : function(result) {
          location.reload();  
        },
        error: function() {
        }
      });  
    });
    // ADD PRODUCT BTN
    $(document).on('click','span.add_product',function(){
      $('.edit_drawer').addClass('active');
      //$('.custom_modal').show();
      $('body').addClass('overlayy');
      $('body').addClass('overflow');
      $('.custom_modal span.add_prodct').show(); 
      $('.custom_modal span.swap_btn').hide();
      $('.custom_modal .qty_changer').show();
      $('.custom_modal .prod_loop input[type="radio"]').hide();
      $('.custom_modal .prod_loop input[type="checkbox"]').show();
      $('.inner_loop').each(function(){
        var token = $(this).attr('token');
        var title = $(this).find('.pro_title h3').text();
        var quantity = $(this).find('input#qunty_box').val();
        //$('.edit_loop[title="'+title+'"]').find('input[type="checkbox"]').prop('checked', true);
        $('.edit_loop[title="'+title+'"]').attr('check','added');
        $('.edit_loop[title="'+title+'"]').find('span.add_box').hide();
        $('.edit_loop[title="'+title+'"]').find('.qty_updater').show();
        $('.edit_loop[title="'+title+'"]').find('input#qunty_ipd').attr('value',quantity);
        $('.edit_loop[title="'+title+'"]').attr('old_qty',quantity);
        $('.edit_loop[title="'+title+'"]').attr('token',token);
       $('.edit_loop[title="'+title+'"]').find('span.remove_btn').show(); 
      });
      $('.custom_modal .add_product-meta').show();
    });
    
    // SHOW ERROR MESSAGE IN ADD PRODUCT
    $(document).on('change','.custom_modal .prod_loop input[name="add_pro"]',function(){
    var total=0;
      $('.custom_modal .prod_loop').each(function(){
        var check = $(this).find('input[type="checkbox"]').prop('checked');
        if(check == true){
      var qty = $(this).find('input#qunty_ipd').val();
      var qty2 = parseInt(qty);
        total = total+qty2;
        }
      });
      if(total == 12 || total == 24 || total == 36){
      $('.custom_modal span.add_prodct').css({'pointer-events':'inherit','background':'#d2483d'}); 
      }
      else {
        $('.custom_modal span.add_prodct').css({'pointer-events':'none','background':'#fe756a'}); 
      }
      if(total > 0 && total <= 12){         
        $('.custom_modal .add_product-meta span.total_products').html('12-Pack Bundle <span class="prc_pck">$53.52</span>');
      }
      else if(total > 12 && total <= 24 ){
        $('.custom_modal .add_product-meta span.total_products').html('24-Pack Bundle <span class="prc_pck">$89.92</span>');
      }
      else if(total > 24 && total <= 36){
        $('.custom_modal .add_product-meta span.total_products').html('36-Pack Bundle <span class="prc_pck">$134.88</span>');
      }
      else if(total > 36 && total <= 48){
        $('.custom_modal .add_product-meta span.total_products').html('48-Pack Bundle <span class="prc_pck">$179.83</span>');
      }
      else if(total > 48 && total <= 60) {
        $('.custom_modal .add_product-meta span.total_products').html('60-Pack Bundle <span class="prc_pck">$224.79</span>');
      } 
      $('.custom_modal span.total_count').text(+total+" Products");
    });
    // UPDATE NEXT SHIPPING DATE
    $(document).on('click','.calender_sec span.update_shipping',function(){
      $(this).css({"pointer-events":"none"}); 
      $('.calender_modal').hide();
      var date = $('.calender_sec input#order_next').val();
    var data = {"date":date}
    var main_arr = [];
    $('section.rct_content .outer_loop .inner_loop').each(function(){
    var url = $(this).attr('token');
   var chk = url.split('?token');
   var first = chk[0];
   var sec = "/set_next_charge_date?token";
   var third = chk[1];
   var final = first+sec+third; 
   main_arr.push(final);   
    });
      function update_shipping(){
        var url_main = main_arr.shift();
        $.ajax({
          type:"POST",
          url:url_main,
          data : data,
          success : function(result) {
            if(main_arr.length > 0){
              update_shipping(); 
            }
            if(main_arr.length == 0){
             location.reload(); 
            }
          }
        }); 
      }
      update_shipping();
    });
    // FOR DELETE OR REMOVE PRODUCT FROM SUBSCRIPTION
    $(document).on('click','.inner_loop span.remove_prod',function(){
      var token_url;
      $('li.rct_navigation__item').each(function(){
        var text = $(this).find('a').text();
        if(text == "Subscriptions"){
          token_url = $(this).find('a').attr('href'); 
        }
      });
      var url = $(this).closest('.inner_loop').attr('token');
      var chk = url.split('?token');
      var first = chk[0];
      var sec = "/cancel?token";
      var third = chk[1];
      var final_url = first+sec+third;
      var data = {"redirect_url":token_url,"cancellation_reason":"Other reason","cancellation_reason_comments":"Thanks"}
      $.ajax({
        type:"POST",
        url:final_url,
        data : data,
        success : function(result) {
          location.reload();            
        }
      });
    });
    // FOR DRAWER BUTTON
    $(document).on('click','.edit_drawer span.add_box',function(){
    $(this).hide(); 
    $(this).next('.qty_updater').show();  
    $(this).closest('.edit_loop').find('span.remove_btn').show();
      var chk_old = $(this).closest('.edit_loop').attr('old_qty');
      if(chk_old == ''){
      $(this).closest('.edit_loop').attr('check','newadded'); 
      }
      else {
      $(this).closest('.edit_loop').attr('check','updated');   
      }
      var total=0;
      $('.edit_drawer .edit_loop').each(function(){
        var check = $(this).attr('check');
        if(check == "added" || check == 'newadded' || check == 'updated' ){
      var qty = $(this).find('input#qunty_ipd').val();
      var qty2 = parseInt(qty);
        total = total+qty2;
        }
      });
      if(total == 12 || total == 24 || total == 36){
      $('.edit_drawer .drawer_footer span.save_btn').css({'pointer-events':'inherit','background':'#d2483d'}); 
      $('.edit_drawer .drawer_footer span.error_msg-qty').hide(); 
      $('.edit_drawer .drawer_footer span.save_btn').text('Save');   
      }
      else {
      $('.edit_drawer .drawer_footer span.save_btn').css({'pointer-events':'none','background':'#fe756a'}); 
      $('.edit_drawer .drawer_footer span.error_msg-qty').show();    
      }  
      if(total > 0 && total < 12){
      var check_remain = 12-total;
     $('.edit_drawer .drawer_footer span.save_btn').text('Add '+check_remain); 
     $('.edit_drawer span.total_count').text(+total+'/12');
      }
      else if(total > 12 && total < 24 ){
      var check_remain = 24-total;
     $('.edit_drawer .drawer_footer span.save_btn').text('Add '+check_remain);  
     $('.edit_drawer span.total_count').text(+total+'/24'); 
      }
      else if(total > 24 && total < 36){
     var check_remain = 36-total;
     $('.edit_drawer .drawer_footer span.save_btn').text('Add '+check_remain);
    $('.edit_drawer span.total_count').text(+total+'/36');  
      }
      else if(total > 36 && total < 48){
     var check_remain = 48-total;
     $('.edit_drawer .drawer_footer span.save_btn').text('Add '+check_remain);  
     $('.edit_drawer span.total_count').text(+total+'/48');   
      }
      else if(total > 48 && total < 60) {
    var check_remain = 60-total;
     $('.edit_drawer .drawer_footer span.save_btn').text('Add '+check_remain);  
    $('.edit_drawer span.total_count').text(+total+'/60');   
      }
    });
    // ON REMOVE CROSS BUTTON CLICK
    $(document).on('click','.edit_drawer .outer_edit span.remove_btn',function(){
    $(this).hide();
    $(this).closest('.edit_loop').find('span.add_box').show();
      var chk_old = $(this).closest('.edit_loop').attr('old_qty'); 
      if(chk_old == ''){
       $(this).closest('.edit_loop').attr('check',''); 
      }
      else {
    $(this).closest('.edit_loop').attr('check','removed'); 
      }
    $(this).closest('.edit_loop').find('.qty_updater').hide();
    var total=0;
      $('.edit_drawer .edit_loop').each(function(){
        var check = $(this).attr('check');
        if(check == "added" || check == 'newadded' || check == 'updated'){
      var qty = $(this).find('input#qunty_ipd').val();
      var qty2 = parseInt(qty);
        total = total+qty2;
        }
      });
      if(total == 12 || total == 24 || total == 36){
      $('.edit_drawer .drawer_footer span.save_btn').css({'pointer-events':'inherit','background':'#d2483d'}); 
      $('.edit_drawer .drawer_footer span.error_msg-qty').hide();  
       $('.edit_drawer .drawer_footer span.save_btn').text('Save');  
      }
      else {
      $('.edit_drawer .drawer_footer span.save_btn').css({'pointer-events':'none','background':'#fe756a'}); 
      $('.edit_drawer .drawer_footer span.error_msg-qty').show();    
      }
      if(total > 0 && total < 12){
      var check_remain = 12-total;
     $('.edit_drawer .drawer_footer span.save_btn').text('Add '+check_remain); 
     $('.edit_drawer span.total_count').text(+total+'/12');   
      }
      else if(total > 12 && total < 24 ){
      var check_remain = 24-total;
     $('.edit_drawer .drawer_footer span.save_btn').text('Add '+check_remain);  
     $('.edit_drawer span.total_count').text(+total+'/24'); 
      }
      else if(total > 24 && total < 36){
     var check_remain = 36-total;
     $('.edit_drawer .drawer_footer span.save_btn').text('Add '+check_remain); 
     $('.edit_drawer span.total_count').text(+total+'/36');  
      }
      else if(total > 36 && total < 48){
     var check_remain = 48-total;
     $('.edit_drawer .drawer_footer span.save_btn').text('Add '+check_remain);  
     $('.edit_drawer span.total_count').text(+total+'/48');   
      }
      else if(total > 48 && total < 60) {
    var check_remain = 60-total;
     $('.edit_drawer .drawer_footer span.save_btn').text('Add '+check_remain);  
     $('.edit_drawer span.total_count').text(+total+'/60');
      }
    });
    // FOR ADD PRODUCT QUANTITY CHANGER
    $(document).on('click','.edit_drawer .bottom_edit .qty_updater span.qty_pls',function(){
     var old_qty =  $(this).closest('.edit_loop').attr('old_qty');
      var old_quantity = parseInt(old_qty);
      var valu = $(this).prev('input[name="upd_qty"]').val();
      valu++;
      if(valu >= 0){
        $(this).prev('input[name="upd_qty"]').attr("value", valu);
      }
      if(old_quantity == valu ){
        $(this).closest('.edit_loop').attr('check','added');
         }
      else if(isNaN(old_quantity)) {
       $(this).closest('.edit_loop').attr('check','newadded'); 
      }
      else {
       $(this).closest('.edit_loop').attr('check','updated'); 
      }
      var total=0;
      $('.edit_drawer .edit_loop').each(function(){
        var check = $(this).attr('check');
        if(check == 'added' || check == 'newadded' || check == 'updated'){
      var qty = $(this).find('input#qunty_ipd').val();
      var qty2 = parseInt(qty);
        total = total+qty2;
        }
      });
      if(total == 12 ){
      $('.edit_drawer .drawer_footer span.save_btn').css({'pointer-events':'inherit','background':'#d2483d'}); 
      $('.edit_drawer .drawer_footer span.error_msg-qty').hide();  
      $('.edit_drawer .drawer_footer span.save_btn').text('Save');
      $('.edit_drawer span.total_count').text(+total+'/12');   
      }
      else if(total == 24 ){
      $('.edit_drawer .drawer_footer span.save_btn').css({'pointer-events':'inherit','background':'#d2483d'}); 
      $('.edit_drawer .drawer_footer span.error_msg-qty').hide();  
      $('.edit_drawer .drawer_footer span.save_btn').text('Save'); 
      $('.edit_drawer span.total_count').text(+total+'/24'); 
      }
          else if(total == 36 ){
        $('.edit_drawer .drawer_footer span.save_btn').css({'pointer-events':'inherit','background':'#d2483d'}); 
        $('.edit_drawer .drawer_footer span.error_msg-qty').hide();  
        $('.edit_drawer .drawer_footer span.save_btn').text('Save');
       $('.edit_drawer span.total_count').text(+total+'/36');      
        }
      else {
      $('.edit_drawer .drawer_footer span.save_btn').css({'pointer-events':'none','background':'#fe756a'}); 
      $('.edit_drawer .drawer_footer span.error_msg-qty').show();    
      }
      if(total > 0 && total < 12){
      var check_remain = 12-total;
     $('.edit_drawer .drawer_footer span.save_btn').text('Add '+check_remain); 
     $('.edit_drawer span.total_count').text(+total+'/12');   
      }
      else if(total > 12 && total < 24 ){
      var check_remain = 24-total;
     $('.edit_drawer .drawer_footer span.save_btn').text('Add '+check_remain);  
     $('.edit_drawer span.total_count').text(+total+'/24');    
      }
      else if(total > 24 && total < 36){
     var check_remain = 36-total;
     $('.edit_drawer .drawer_footer span.save_btn').text('Add '+check_remain);  
     $('.edit_drawer span.total_count').text(+total+'/36');    
      }
      else if(total > 36 && total < 48){
     var check_remain = 48-total;
     $('.edit_drawer .drawer_footer span.save_btn').text('Add '+check_remain);  
    $('.edit_drawer span.total_count').text(+total+'/48');     
      }
      else if(total > 48 && total < 60) {
    var check_remain = 60-total;
     $('.edit_drawer .drawer_footer span.save_btn').text('Add '+check_remain);  
     $('.edit_drawer span.total_count').text(+total+'/60');    
      }
    });
    $(document).on('click','.edit_drawer .bottom_edit .qty_updater span.qty_mns',function(){
      var old_qty =  $(this).closest('.edit_loop').attr('old_qty');
      var old_quantity = parseInt(old_qty);
      var valu = $(this).next('input[name="upd_qty"]').val();
      valu--;
      if(valu >= 1){
        $(this).next('input[name="upd_qty"]').attr("value", valu);
      }
      var total=0;
     $('.edit_drawer .edit_loop').each(function(){
        var check = $(this).attr('check');
        if(check == "added" || check == 'newadded' || check == 'updated'){
      var qty = $(this).find('input#qunty_ipd').val();
      var qty2 = parseInt(qty);
        total = total+qty2;
        }
      });
      if(old_quantity == valu ){
        $(this).closest('.edit_loop').attr('check','added');
         }
      else if(isNaN(old_quantity)) {
       $(this).closest('.edit_loop').attr('check','newadded'); 
      }
      else {
       $(this).closest('.edit_loop').attr('check','updated'); 
      }
      if(total == 12 ){
      $('.edit_drawer .drawer_footer span.save_btn').css({'pointer-events':'inherit','background':'#d2483d'}); 
      $('.edit_drawer .drawer_footer span.error_msg-qty').hide();  
      $('.edit_drawer .drawer_footer span.save_btn').text('Save');
      $('.edit_drawer span.total_count').text(+total+'/12');   
      }
      else if(total == 24 ){
      $('.edit_drawer .drawer_footer span.save_btn').css({'pointer-events':'inherit','background':'#d2483d'}); 
      $('.edit_drawer .drawer_footer span.error_msg-qty').hide();  
      $('.edit_drawer .drawer_footer span.save_btn').text('Save'); 
      $('.edit_drawer span.total_count').text(+total+'/24'); 
      }
          else if(total == 36 ){
        $('.edit_drawer .drawer_footer span.save_btn').css({'pointer-events':'inherit','background':'#d2483d'}); 
        $('.edit_drawer .drawer_footer span.error_msg-qty').hide();  
        $('.edit_drawer .drawer_footer span.save_btn').text('Save');
       $('.edit_drawer span.total_count').text(+total+'/36');      
        }
      else {
      $('.edit_drawer .drawer_footer span.save_btn').css({'pointer-events':'none','background':'#fe756a'}); 
      $('.edit_drawer .drawer_footer span.error_msg-qty').show();    
      }
      if(total > 0 && total < 12){
      var check_remain = 12-total;
     $('.edit_drawer .drawer_footer span.save_btn').text('Add '+check_remain); 
     $('.edit_drawer span.total_count').text(+total+'/12');    
      }
      else if(total > 12 && total < 24 ){
      var check_remain = 24-total;
     $('.edit_drawer .drawer_footer span.save_btn').text('Add '+check_remain); 
     $('.edit_drawer span.total_count').text(+total+'/24');    
      }
      else if(total > 24 && total < 36){
     var check_remain = 36-total;
     $('.edit_drawer .drawer_footer span.save_btn').text('Add '+check_remain);    
     $('.edit_drawer span.total_count').text(+total+'/36');    
      }
      else if(total > 36 && total < 48){
     var check_remain = 48-total;
     $('.edit_drawer .drawer_footer span.save_btn').text('Add '+check_remain); 
     $('.edit_drawer span.total_count').text(+total+'/48');    
      }
      else if(total > 48 && total < 60) {
    var check_remain = 60-total;
     $('.edit_drawer .drawer_footer span.save_btn').text('Add '+check_remain);  
    $('.edit_drawer span.total_count').text(+total+'/60');     
      }
    }); 
   
    
    // FOR DRAWER ACCORDIAN
    $(document).on('click','span.accordian_toggle',function(){
      var text = $(this).text();
      if(text == '-'){
        $('.slider_sec-top').addClass('active');
        $(this).text('+');
      }
      else {
        $('.slider_sec-top').removeClass('active');
        $(this).text('-');       
      }
    });
    // FOR CLOSE DRAWER
    $(document).on('click','.edit_drawer span.close_btn , .edit_drawer span.back_btn',function(){
    $('.edit_drawer').removeClass('active');  
    $('body').removeClass('overlayy');
    $('body').removeClass('overflow');  
    });
    
    
    // FOR ADD, UPDATE PRODUCT
    $(document).on('click','.edit_drawer .drawer_footer span.save_btn',function(){
      $('.drawer_footer img.loader_img').show();
      var adrs_id2 = $('.rct_subscriptions__container section').attr('data-address-id');
     var adrs_id = parseInt(adrs_id2);
     var frequency2 = $('select#frequency_drop').val();
     var frequency = parseInt(frequency2);
     var var_id;
     var quantity;
      var new_added = [];
      var updated_pro = [];
      var delete_arr = [];
      var token_url;
      $('.custom_modal').hide();
      $('li.rct_navigation__item').each(function(){
        var text = $(this).find('a').text();
        if(text == "Subscriptions"){
          token_url = $(this).find('a').attr('href'); 
        }
      });
      // DELETE PRODUCT
      $('.edit_loop[check="removed"]').each(function(){
     var url = $(this).attr('token');
     var chk = url.split('?token');
     var first = chk[0];
     var sec = "/cancel?token";
     var third = chk[1];
     var final_url = first+sec+third; 
     delete_arr.push(final_url);
      });
     
      // PUSH NEW PRODUCT ELEMENT
      $('.edit_loop[check="newadded"]').each(function(){
      var var_id = $(this).attr('var-id') ;
      var quantity2 = $(this).find('.qty_updater input#qunty_ipd').val();
      var quantity = parseInt(quantity2);  
      new_added.push({"shopify_variant_id":var_id,"quantity":quantity});  
      });
      // UPDATE OLD PRODUCT 
      var updated_qty;
      $('.edit_loop[check="updated"]').each(function(){
        var token = $(this).attr('token');
        var qunty = $(this).find('.qty_updater input#qunty_ipd').val();
        var updated_qty = parseInt(qunty);
      updated_pro.push({"token":token,"quantity":qunty});
      });
      // GET NEXT SHIPPING DATE AND TRANSLATE
      var currentYear = (new Date).getFullYear();
      var get_top = $('div#calender_modal span.current_date').text(); 
      var get_date = get_top;
      var math_date = get_date.match(/\d+/);
      var month = get_date.replace(/[^A-Za-z]/g, '');
      if(month == 'January'){
        var math_month = "01";
      }
      else if(month == 'February'){
        var math_month = "02";
      }
      else if(month == 'March'){
        var math_month = "03";
      }
      else if(month == 'April'){
        var math_month = "04";
      }
      else if(month == 'May'){
        var math_month = "05";
      }
      else if(month == 'June'){
        var math_month = "06";
      }
      else if(month == 'July'){
        var math_month = "07";
      }
      else if(month == 'August'){
        var math_month = "08";
      }
      else if(month == 'September'){
        var math_month = "09";
      }
      else if(month == 'October'){
        var math_month = "10";
      }
      else if(month == 'November'){
        var math_month = "11";
      }
      else if(month == 'December'){
        var math_month = "12";
      }
      var updated_date=currentYear+'-'+math_month+'-'+math_date;
      // DELETE FUNCTION
      function delete_qty(){
        var del_arry = delete_arr.shift();
       var data = {"redirect_url":token_url,"cancellation_reason":"Other reason","cancellation_reason_comments":"Thanks"}
      $.ajax({
        type:"POST",
        url:del_arry,
        data : data,
        success : function(result) {
          if(delete_arr.length > 0){
          delete_qty();  
          }
          if(delete_arr.length == 0) {
          $('.edit_drawer').removeClass('active');
          location.reload();  
          }
        },
        error:function(){
        $('.edit_drawer').removeClass('active'); 
        location.reload();  
        }
      }); 
      }
      // UPDATE FUNCTION
      function updated_qty(){
         if(updated_pro.length > 0){
        var shifted_arr = updated_pro.shift();
        var check_qty = shifted_arr['quantity'];
        var check_token = shifted_arr['token'];
        var data = {"quantity":check_qty}
        $.ajax({
          type:"POST",
          url:check_token,
          data : data,
          success : function(result) {
            if(updated_pro.length > 0){
              updated_qty();
            }
            if(updated_pro.length == 0){
             delete_qty();
            }
          },
          error:function(){
           delete_qty(); 
          }
        }); 
      }
        else {
         delete_qty(); 
        }
      }
      if($('.edit_loop[check="newadded"]').length){
      }
      else {
      updated_qty();    
      }
      // ADD NEW PRODUCT
      function add_pro_main(){
    var array_main = new_added.shift();
    var quantity = array_main['quantity'];
    var var_id = array_main['shopify_variant_id']; 
    var data = {"address_id":adrs_id,"charge_interval_frequency":frequency,"next_charge_scheduled_at":updated_date,"order_interval_frequency":frequency,"order_interval_unit":"week","purchase_type":"subscription","quantity":quantity,"redirect_url":token_url,"shopify_variant_id":var_id}  
  console.log(new_added);
        $.ajax({
    type:"POST",
    url:token_url,
    data : data,
    success : function(result) {
      if(new_added.length > 0){  
      add_pro_main();
      }
      else {
        var test = $('.edit_loop[check="updated"]').length;
        if(test == 0){
          $('.edit_drawer').removeClass('active');
        location.reload();
        }
        else {
        updated_qty();
        }
      }
    },
    error: function() {
    updated_qty();
    }
  }); 
  }
      add_pro_main();
    });
    
    // FOR SEARCH BAR
    $(document).on('keyup','.drawer_search input[type="text"]',function(){
      $('.edit_loop').hide();
      var main_val = $(this).val().toLowerCase();
      $('.edit_loop').each(function(){
      var title = $(this).attr('title');
      var main_title = title.toLowerCase();    
      if (main_title.indexOf(main_val) >= 0){
      $(this).show();
      }
      else {
      $(this).hide();
      }
      });
      });
    // for mobile buttons 
  $(document).on('click','span.change_date',function(){
$('span.update_shipmnt').trigger('click');
});
    $(document).on('click','span.edit_box',function(){
$('section.rct_content span.add_product').trigger('click');
});
    // FOR CANCEL SUBSCRIPTION POPUP
    $(document).on('click','.cancel_subsc_pop span.cancel_subsc',function(){
      $(this).hide();
      $('.cancel_subscription').show();
      $('body').addClass('overflow');
    });
    $(document).on('click','.cancel_subscription span.close',function(){
    $('.cancel_subscription').hide();
    $('body').removeClass('overflow');  
    });
    $(document).on('change','.cancel_resons input[name="retention_strategy_id"]',function(){
    $('div#cancel_subscription span.cancel_save').css({"pointer-events":"unset"});    
    });
  // Cancel Subscription
    $(document).on('click','div#cancel_subscription span.cancel_save',function(){
      $('.cancel_subscription').hide();
      $('.cancel_subsc_pop span.loader_img').show();
      var cancel_array = [];
      var token_url = [];
    var reason = $('.cancel_resons input[name="retention_strategy_id"]:checked').val();
      
   $('li.rct_navigation__item').each(function(){
        var text = $(this).find('a').text();
        if(text == "Subscriptions"){
          token_url = $(this).find('a').attr('href'); 
        }
      });
      $('.outer_loop .inner_loop').each(function(){
     var url = $(this).attr('token');
     var chk = url.split('?token');
     var first = chk[0];
     var sec = "/cancel?token";
     var third = chk[1];
     var final_url = first+sec+third; 
     cancel_array.push(final_url);
      });
function cancel_subsc(){
        var new_cancel_arry = cancel_array.shift();
       var data = {"redirect_url":token_url,"cancellation_reason":reason,"cancellation_reason_comments":"Thanks"}
      $.ajax({
        type:"POST",
        url:new_cancel_arry,
        data : data,
        success : function(result) {
          if(cancel_array.length > 0){
          cancel_subsc();  
          }
          if(cancel_array.length == 0) {
          location.reload();  
          }
        }
      }); 
}
      cancel_subsc();
      $('.cancel_subscription').hide();
      $('body').removeClass('overflow');
      });

// REACTIVATE CANCELED SUBSCRIPTION
var check_active = setInterval(function(){
if($('p.rct_chip').length){
$('<span class="react_btn">REACTIVATE SUBSCRIPTION</span><span class="loader_img-second" style="display:none;"><img src="//cdn.shopify.com/s/files/1/0568/6840/5424/files/loader_218x.gif?v=1661952573"></span>').insertAfter('section.rct_content .cancel_subsc_pop');
$('.cancel_subsc_pop').hide();  
  clearInterval(check_active);
}
  },1000);
    
$(document).on('click','section.rct_content span.react_btn',function(){
$('span.loader_img-second').show();
$('.rct_subscriptions__container').each(function(index){
if(index == 1 || index == 0){
var react_arr = []; 
$(this).find('.rct_card').each(function(){
var url = $(this).attr('data-subscription-item');
 var chk = url.split('?token');
var first = chk[0];   
    var sec = "/activate?token";
     var third = chk[1];
     var final_url = first+sec+third; 
    var token_next = third.split('=');
     var token = token_next[1];
    react_arr.push({"token":token,"url":final_url});
});
  
function reactivate_main(){
var new_arr = react_arr.shift();
        var token_main = new_arr['token'];
        var url_new = new_arr['url'];
    var data = {"token":token_main}    
      $.ajax({
        type:"POST",
        url:url_new,
        data : data,
        success : function(result) {
         if(react_arr.length == 0){
      location.reload();
         }
            if(react_arr.length > 0){
       reactivate_main();
            }
        }
      });
}
    reactivate_main();
}
  
});
});

$(document).ready(function(){
$('#owl-demo5').owlCarousel({
    loop:true,
    lazyLoad:true,
    margin:0,
    autoplay: true,
    nav:true,
    autoplaySpeed: 1500,
    mobileFirst: true,
    responsiveClass:true,
    responsive:{
      0:{
        items:1,
      },
      480:{
        items:2,
      },
      767:{
        items:3,
      },
      991:{
        items:4,
      },
      1200:{
        items:5,
      }
    }
});

$('#owl-demo2').owlCarousel({
    loop:false,
    margin:0,
    nav: true,
    autoplay: false,
    autoplaySpeed: 1500,
    mobileFirst: true,
    responsiveClass:true,
    responsive:{
      0:{
        items:1,
      },
      480:{
        items:1,
      },
      768:{
        items:2,
      },
      992:{
        items:2,
      }
    }
});

$('#owl-demo3').owlCarousel({
    loop:false,
    margin:0,
    nav: true,
    autoplay: false,
    autoplaySpeed: 1500,
    mobileFirst: true,
    responsiveClass:true,
    responsive:{
      0:{
        items:1,
      },
      480:{
        items:1,
      },
      768:{
        items:2,
      },
      992:{
        items:2,
      }
    }
});
  
});


